import React from "react";
const PolicyEnabled = ({ enabled }) => {
    return enabled ? React.createElement(React.Fragment, null, "\u2713") : React.createElement(React.Fragment, null, "Disabled");
};
export default PolicyEnabled;
//# sourceMappingURL=PolicyEnabled.js.map